// eslint-disable-next-line no-unused-vars
import { BaseStrategy } from '@/lib'

/**
 * A registry for storing and managing strategy classes.
 * This registry provides methods to register and retrieve strategies.
 */
export class StrategiesRegistry {
  /**
   * Returns the registry of all registered strategies.
   * Initializes `_registry` if it has not been created yet.
   *
   * @returns {Array<typeof BaseStrategy>} The array of registered strategy classes.
   */
  static get registry() {
    if (!this._registry) {
      this._registry = []
    }
    return this._registry
  }

  /**
   * Registers a strategy class to the registry.
   *
   * @param {typeof BaseStrategy} strategyClass - The strategy class to register. Must be a subclass of `BaseStrategy`.
   */
  static register(strategyClass) {
    this.registry.push(strategyClass)
  }

  /**
   * Retrieves all registered strategy classes.
   *
   * @returns {Array<typeof BaseStrategy>} Array of all registered strategy classes.
   */
  static getAllStrategies() {
    return this.registry
  }
}
